import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { IAdvanceFilter } from '../../../../shared/advanced-filters/components/advance-filter';
import { IGetSavedListingFiltersResponseDTO } from '../../../../shared/save-listing-filters/save-filters.dto';
import { IMetadataListDTO } from '../../../settings/documentfields/metadata-item.dto';
import { ContractControlAdvanceFilterParamType } from '../../advanced-filters';
import { IGetImportResponseDTO } from '../../get-imports.dto';
import { ContractControlKey } from '../contract-control.config';
import { IExportContractControlRequest } from '../dto/export-request';
import { IColumnSettings } from 'app/main/shared/shared/table/components/custom-columns-settings/column-settings';


const scope = `[${ContractControlKey}]`;


export const resetState = createAction(`${scope} Reset Contract Control State`);
export const exportContractControlData = createAction(`${scope} Export Contract Control Data`, props<{exportOptions: IExportContractControlRequest}>());
export const exportContractControlDataSuccess = createAction(`${scope} Export Contract Control Data Success`);
export const exportContractControlDataFailure = createAction(`${scope} Export Contract Control Data Failure`, props<{error:HttpErrorResponse}>());

export const continueImport = createAction(`${scope} Continue Import`, props<{id:number}>());
export const importDetailsFetchSuccess = createAction(`${scope} Import Details Fetch Success`, props<{result:IGetImportResponseDTO}>());
export const importDetailsFetchFailed = createAction(`${scope} Import Details Fetch Failed`, props<{error:HttpErrorResponse}>());

export const setAdvancedDocumentFilters = createAction(`${scope} Set Advanced Document Filters`, props<{filters: Partial<IAdvanceFilter<ContractControlAdvanceFilterParamType>[]>}>())
export const clearAdvancedFiltersOnDestroy = createAction(`${scope} Clear Advanced Filters On Destroy`)
export const fetchAdvancedFilters = createAction(`${scope} Fetch Advanced Filters`);
export const fetchAdvancedFiltersSuccess = createAction(`${scope} Fetch Advanced Filters Success`, props<{
    metadata: IMetadataListDTO
}>());
export const fetchAdvancedFiltersFailure = createAction(`${scope} Fetch Advanced Filters Failure`, props<{
    error: HttpErrorResponse
}>());
export const advancedFilterSearch = createAction(`${scope} Advanced Filter Search`, props<{ searchString: string }>());
export const addAdvancedFilterGroup = createAction(`${scope} Add Advanced Filter Group`, props<{
    filter: Omit<IAdvanceFilter<ContractControlAdvanceFilterParamType>,'uuid'>,
}>());
export const addAdvancedFilter = createAction(`${scope} Add Advanced Filter`, props<{
    filter: Omit<IAdvanceFilter<ContractControlAdvanceFilterParamType>,'uuid'>
}>());
export const removeAdvancedFilter = createAction(`${scope} Remove Advanced Filter`, props<{
    filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>
}>());
export const updateAdvancedFilter = createAction(`${scope} Update Advanced Filter`, props<{
    filter: IAdvanceFilter<ContractControlAdvanceFilterParamType>
}>());

export const onFilterClose = createAction(`${scope} On Filter Close`, props<{
    filter: Partial<IAdvanceFilter<ContractControlAdvanceFilterParamType>>
}>());

export const restoreFilter= createAction(`${scope} Restore Filter`, props<{
    filterId: number
}>());

export const editFilter= createAction(`${scope} Edit Filter`, props<{
    filter: Partial<IGetSavedListingFiltersResponseDTO>
}>());

export const deleteFilter= createAction(`${scope} Delete Filter`, props<{
    filterId: number
}>());

export const importPDFSuccessNotification =   createAction(`${scope} Import PDF Success Notification`);

export const fetchCustomColumnSettings = createAction(`${scope} Fetch Custom Column Settings`);
export const fetchCustomColumnSettingsSuccess = createAction(`${scope} Fetch Custom Column Settings Success`, props<{
    columnSettings: IColumnSettings[]
}>());
export const fetchCustomColumnSettingsFailure = createAction(`${scope} Fetch Custom Column Settings Failure`, props<{
    error: HttpErrorResponse
}>());
export const setCustomColumnSettings = createAction(`${scope} Set Custom Column Settings`, props<{
    columnSettings: IColumnSettings[]
}>());
